import $ from 'jquery';
import Emitter from 'es6-emitter'
const jQuery = $;
window.jQuery = jQuery;
import '@bower_components/Snap.svg';
import svgPanZoom from '@bower_components/svg-pan-zoom';
import Hammer from '@bower_components/hammerjs';
require('bootstrap');

import '@bower_components/moment';
import '@bower_components/moment/locale/de';
import {
  Router
} from '@bower_components/director/build/director';
//import '@bower_components/c3';
//import '@bower_components/d3';
import localforage from '@bower_components/localforage';
import select2 from '@bower_components/select2/dist/js/select2';

select2($);
$.fn.select2.defaults.set("theme", "bootstrap");

/*
< script src = "/bower_components/d3/d3.js" > < /script> <
  script src = "/bower_components/c3/c3.js" > < /script> <
  script src = "/bower_components/moment/moment.js" > < /script> <
  script src = "/bower_components/moment/locale/de.js" > < /script> <
  script src = "/bower_components/domurl/url.js" > < /script> <
  script src = "/bower_components/select2/select2.js" > < /script> <
  script src = "/bower_components/localforage/dist/localforage.js" > < /script> <
  script src = "/bower_components/jquery-sortable/source/js/jquery-sortable.js" > < /script>
*/

import Plan from '../plans/plan.js';
import eventsHandler from '../plans/hammer_handler.js';
import Printer from '../plans/print.js';

// runtime variables
var panZoom;
var container = $('.map-container');
var s;
var print;
var storeLocal = false;
var allFetched = false;

/** set height and width on the map */
function setBoundings() {
  container = $('.map-container');
  var width = container.width();
  var offsetTop = container.offset().top;
  var height = $(window).height();

  if (offsetTop < height) {
    height -= container.offset().top;
  }

  $('#Map').attr({height: height, width: width}).attr('class', 'display');
}

// helper functions
/** resize the svg object and fits the plan in it */
function resizePlan() {
  setBoundings();
  if (panZoom) {
    panZoom.resize();
    panZoom.fit();
    panZoom.center();
  }
}

($ => {
if ($('#Map').length) {

  s = new Snap('#Map');
  var locations = $('#LocationSwitch');
  var buildings = $('#BuildingSwitch');
  var floors = $('#FloorSwitch');
  var storageButton = $('.store-local-state');
  var data = null;
  var title;
  // var panZoom;

  var roomColors = {
    unavailable: '#ccc',
    function: '#ccc',
    workshop: '#5fcfe7',
    storage: '#69bab4',
    reserved: '#f79fff',
    occupied: '#ff6666',
    terminated: '#f3fd58',
    seminar: '#b1fbff',
    free: '#1ada55',
    hover: '#6493d5',
    text: '#111'
  };

  var router = new Router().configure({html5history: false});
  router.param('slugid', /([\w-\d]+)/);

  router.configure({
    recurse: 'forward',
    after: function() {
      router.lastHash = router.currentHash;
      router.currentHash = window.location.hash.substr(1);
    }
  });

  router.mount({
    '/': {
      before: function() {
        // console.log(router.lastHash);
        // console.log(router.currentHash);
        if (router.currentHash === '/') {
          window.history.go(-2);
          console.log('back');
          return false;
        }
      }
    }
  });

  /**
   * change class on state button
   */
  function displayStateButton() {
    if (storeLocal && allFetched) {
      storageButton.removeClass(
        'btn-danger').removeClass('btn-warning').addClass('btn-success');
      storageButton.text('Offline-Mode BEREIT');
    } else if (storeLocal && !allFetched) {
      storageButton.removeClass(
        'btn-danger').removeClass('btn-success').addClass('btn-warning');
      storageButton.text('Offline-Mode wird geladen ...');
    } else {
      storageButton.removeClass(
        'btn-success').removeClass('btn-warning').addClass('btn-danger');
      storageButton.text('Offline-Mode AUS');
    }
  }

  $(document).ready(() => {
    setBoundings();
    print = new Printer(panZoom, resizePlan);
    print.on();

    $('#collapseHeader').on('shown.bs.collapse hidden.bs.collapse', () => {
      resizePlan();
    });

    $('#collapseHeader').on('shown.bs.collapse', () => {
      $('.show-admintitle i').attr('class', 'glyphicon glyphicon-chevron-up');
    });

    $('#collapseHeader').on('hidden.bs.collapse', () => {
      $('.show-admintitle i').attr('class', 'glyphicon glyphicon-chevron-down');
    });

    localforage.getItem('storeLocal', (err, value) => {
      if (err) {
        console.log(err);
      } else {
        var prevState = storeLocal;
        storeLocal = value;
        // TODO: trigger local storing
        storageButton.trigger('local-state-change', prevState);
      }
      loadJson();
    });

    $('.store-local-state').on('click', () => {
      var prevState = storeLocal;
      storeLocal = !prevState;
      localforage.setItem('storeLocal', storeLocal);
      // TODO: trigger local storing
      storageButton.trigger('local-state-change', prevState);
    });

    $('.store-local-state').on('local-state-change', (event, prevState) => {
      displayStateButton();
      if (!prevState && storeLocal) {
        container.one('all-plans-fetched', () => {
          allFetched = true;
          displayStateButton();
        });
        if (data) {
          fetchAllPlans();
        } else {
          locations.one('change', fetchAllPlans);
        }
      } else {
        allFetched = false;
      }
    });
  });

  $(window).resize(resizePlan);

  // selects the option tag where its data(dataName).slug == slug
  /**
   * return data of selected option or false
   * @param  {jQuerySelector} selection - the <select> to look in
   * @param  {string} slug - slug of the item to find
   * @param  {string} dataName - name of the data store
   * @return {mixed} the matching data or false
   */
  function selectBySlug(selection, slug, dataName) {
    var madeSelection = false;
    selection.find('option').each((i, el) => {
      var d = $(el).data(dataName);
      if (d.slug === slug) {
        $(el).attr('selected', 'selected');
        madeSelection = d;
        // break loop
        return false;
      }
    });
    return madeSelection;
  }

  // resets all option tags inside the selection
  /**
   * save each item of the data array inside data(dataName)
   * @param  {jQuerySelector} selection <select> to populate
   * @param  {[type]} dataArray array of data objects
   * @param  {[type]} dataName  name with which data is stored
   */
  function populateSelection(selection, dataArray, dataName) {
    selection.empty();

    $.each(dataArray, (i, el) => {
      selection.append($('<option />').val(el.id).text(el.name));
      selection.find('option:last()').data(dataName, el);

      if (el.pos === 0) {
        selection.find('option:last()').attr('selected', 'selected');
      }
    });
  }

  /**
   * creates a uri of *.slug from selected data objects
   * @return {string} uri
   */
  function getUrl() {
    var location = locations.find(':selected').data('location');
    var building = buildings.find(':selected').data('building');
    var floor = floors.find(':selected').data('floor');
    return location.slug + '/' + building.slug + '/' + floor.slug;
  }

  /**
   * entry point into app, load all locations from server
   */
  function loadJson() {
    jQuery.getJSON('/admin/json', result => {
      data = result.results;
      if (storeLocal) {
        localforage.setItem('/admin/json', data);
      }
      populateSelection(locations, data, 'location');
      locations.trigger('change');
    }).fail(() => {
      localforage.getItem('/admin/json').then((err, value) => {
        if (err) {
          console.log(err);
        } else {
          data = value;
          populateSelection(locations, data, 'location');
          locations.trigger('change');
        }
      });
    });
  }
  // event listeners
  container.on('plan-loaded', event => {
    $(event.currentTarget).find('#Map').removeClass('loading');
    $('.title > span').html(title);
    resizePlan();
  });

  container.on('plan-loading', event => {
    let elem = $(event.currentTarget);
    elem.find('#Map').addClass('loading');
    $('.title > span').text('Plan wird geladen ...');
  });

  container.on('plan-fetching');
  container.on('plan-fetched');

  locations.on('change', event => {
    let elem = $(event.currentTarget);
    var location = elem.find(':selected').data('location');
    populateSelection(buildings, location.buildings, 'building');

    buildings.trigger('change');
  });

  buildings.on('change', event => {
    let elem = $(event.currentTarget);
    var building = elem.find(':selected').data('building');
    populateSelection(floors, building.floors, 'floor');

    floors.trigger('change');
  });

  floors.one('change', () => {
    var route = router.getRoute();
    // monkey patch, index route is not called, when route is empty
    if (route[0] === '') {
      route = '/';
    }
    router.init(route);

    floors.on('change', () => {
      router.setRoute(getUrl());
    });
  });

  router.on('/$', () => {
    router.setRoute(getUrl());
  });

  router.on('/:slugid/:slugid/:slugid',
  (locationSlug, buildingSlug, floorSlug) => {
    var selectedLocation = selectBySlug(
      locations, locationSlug, 'location') || data[0];

    populateSelection(buildings, selectedLocation.buildings, 'building');
    var selectedBuilding = selectBySlug(
      buildings, buildingSlug, 'building') || selectedLocation.buildings[0];

    populateSelection(floors, selectedBuilding.floors, 'floor');
    var selectedFloor = selectBySlug(
      floors, floorSlug, 'floor') || selectedBuilding.floors[0];

    container.trigger('plan-loading');
    title = selectedLocation.name + ' | ' +
      (selectedBuilding.name ? selectedBuilding.name + ' | ' : '') +
      selectedFloor.name;

    showPlan(selectedFloor, selectedBuilding, selectedLocation);
  });

  //
  // svg manipulations
  //

  /**
   * init fetch off a Plan given its tupel, init render when done
   * @param  {object} floor    contains the selected floor obj
   * @param  {object} building selected building
   * @param  {object} location selected location
   */
  function showPlan(floor, building, location) {
    container.one('plan-fetched', (event, f) => {
      renderPlan(f, floor, building, location);
    });
    loadSVG(floor.plan);
  }

  /**
   * load all plans into storage
   */
  function fetchAllPlans() {
    var floors = [];
    var todo = [];

    /**
     * checl plan-fetching progress
     * @param  {object} event jquery event
     * @param  {object} f     svg fragment
     * @param  {string} plan  plan filename
     */
    function progressCheck(event, f, plan) {
      todo.push(plan);
      if (todo.length === floors.length) {
        container.off('plan-fetched', progressCheck);
        if (todo.length > 0) {
          container.trigger('all-plans-fetched');
        }
      }
    }

    container.off('plan-fetched', progressCheck);

    jQuery.each(data, (index, value) => {
      jQuery.each(value.buildings, (index, value) => {
        jQuery.each(value.floors, (index, value) => {
          floors.push(value.plan);
        });
      });
    });

    if (floors) {
      jQuery.each(floors, (index, value) => {
        loadSVG(value, true);
      });

      container.on('plan-fetched', progressCheck);
    }
  }

  /**
   * loads the svg file from server or from storage
   * @param  {string} svgFilename    contains the selected svg filename
   * @param  {bool} renew    skip local storage, when true
   */
  function loadSVG(svgFilename, renew) {
    var ajaxLoad = () => {
      Snap.load('/plans/' + svgFilename, f => {
        if (f.node.childElementCount) {
          if (storeLocal) {
            localforage.setItem(svgFilename, f.node.outerHTML);
          }
          container.trigger('plan-fetched', [f, svgFilename]);
        }
      });
    };

    if (storeLocal && !renew) {
      localforage.getItem(svgFilename, (err, value) => {
        if (err) {
          ajaxLoad();
        } else {
          container.trigger('plan-fetched', [Snap.parse(value), svgFilename]);
        }
      });
    } else {
      ajaxLoad();
    }
  }

  /**
   * replace the loaded fragment with the given one
   * @param  {object} fragment new svg fragment
   * @param  {object} floor    contains the selected floor obj
   * @param  {object} building selected building
   * @param  {object} location selected location
   */
  function renderPlan(fragment, floor, building, location) {
    var g = fragment.select('g[class="SlideGroup Slide Page"]');
    s.clear();
    s.append(g);

    // renderSVG(floor, building, location);
    var plan = new Plan(s, floor, building, location);
    plan.paintRooms(getColor);
    var fontSize = 320;
    if (location.id === 3) {
      fontSize = 500;
    }

    if (location.id === 4) {
      fontSize = 700;
    }

    var draw = function(node, g, nameBBox, setTextAttr, localFontSize) {
      if (node.data.number &&
        node.data.name.search(/[,/]/g) !== -1 && name !== node.data.number) {
        // only create number text if name has a komma name is not the same as number
        let nr = node.data.number.replace(/.+[,/]/g, '');
        let nrText = node.room.text(0, nameBBox.h, nr);
        setTextAttr(nrText);
        // add text to group
        g.add(nrText);
      }

      let showArea = node.data.area && node.data.type !== 1;
      if (showArea) {
        // only create area text if room is free and there is a area
        let areaText = node.room.text(0, nameBBox.h * 2,
          Number(node.data.area).toLocaleString() + ' m²');
        setTextAttr(areaText);
        // add text to group
        g.add(areaText);
      }

      let nextHeight;
      if (node.data.clients && node.data.clients.length > 0) {
        // console.log(node.data.clients);
        // only create area text if room is free and there is a area
        nextHeight = (showArea) ? nameBBox.h * 3 : nameBBox.h * 2;
        let clientText = node.room.text(0, nextHeight,
          node.data.clients[0].display_name);
        setTextAttr(clientText);
        clientText.attr({'font-size': localFontSize * 0.8});
        // add text to group
        g.add(clientText);
      }

      if (node.data.soon_free) {
        // only create area text if room is free and there is a area
        nextHeight = (nextHeight) ? nameBBox.h * 4 : nameBBox.h * 3;
        var dateText;
        if (node.data.already_reserved) {
          dateText = node.room.text(0, nextHeight,
          'reserviert ab: ' + moment(node.data.soon_free).format('DD.MM.YY'));
        } else {
          dateText = node.room.text(0, nextHeight,
          'frei ab: ' + moment(node.data.soon_free).format('DD.MM.YY'));
        }

        setTextAttr(dateText);
        dateText.attr({'font-size': localFontSize * 0.8});
        // add text to group
        g.add(dateText);
      }

      if (node.data.note) {
        var title = Snap.parse('<title>' + node.data.note + '</title>');
        node.room.append(title);
      }
    };

    plan.drawTexts(roomColors.text, fontSize, draw);
    plan.removeUnwantedNode();

    // recreate panzoom, because the slidegroup has been overwritten
    if (panZoom) {
      panZoom.destroy();
    }
    panZoom = svgPanZoom('#Map', {
      viewportSelector: '.SlideGroup',
      customEventsHandler: eventsHandler
    });

    print.panzoom = panZoom;
    // publish loaded
    container.trigger('plan-loaded');
  }

  /**
   * assign a color to a room
   * @param  {object} room selected room object
   * @return {string}      color
   */
  function getColor(room) {
    var color = '#fff';
    /**
      (1, _('Function room')),
      (2, _('Office')),
      (3, _('Workshop')),
      (4, _('Seminar Room')),
      (5, _('Storage')),

      (1, _('Free')),
      (2, _('Occupied')),
      (3, _('Reserved')),
     */
    if (room.occupancy === 3) {
      color = roomColors.reserved;
    }
    if (room.occupancy === 2) {
      color = roomColors.occupied;

      if (room.soon_free) {
        color = roomColors.terminated;

        if (room.already_reserved) {
          color = roomColors.reserved;
        }
      }
    }
    if (room.occupancy === 1) {
      color = roomColors.free;

      // if (room.type === 3) {
      //   color = roomColors.workshop;
      // }

      if (room.type === 4) {
        color = roomColors.seminar;
      }

      // if (room.type === 5) {
      //   color = roomColors.storage;
      // }

      if (room.type === 1) {
        color = roomColors.function;
      }
    }
    return color;
  }
}})(jQuery);
